import styled from 'styled-components';

import { CUST } from '../../../../theme/customizer-tokens';

export const Shell = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
`;

export const TopBar = styled.div`
  position: relative;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  padding: 12px 16px;
`;

export const BackBtn = styled.button`
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  background: transparent;
  color: ${CUST.white};
  cursor: pointer;
`;

/** Centered progress cluster: 3 short bars + a globe (the "go live" step). While
 *  the intro→rail morph runs, the real cluster is hidden ($entering) so the flying
 *  ghost clones own all the motion; it reveals (binary, no transition) at the
 *  handoff, already pixel-aligned with where the ghosts landed. */
export const Progress = styled.div<{ $entering?: boolean }>`
  display: flex;
  align-items: center;
  gap: 5px;
  opacity: ${({ $entering }) => ($entering ? 0 : 1)};
`;

export const Bar = styled.div<{ $on: boolean; 'data-chrome-stage'?: number }>`
  width: 46px;
  height: ${({ $on }) => ($on ? '6px' : '4px')};
  border-radius: 18px;
  background: ${({ $on }) => ($on ? CUST.progressFill : CUST.mobileTrack)};
`;

export const GlobeStep = styled.span<{ $on: boolean; 'data-chrome-stage'?: number }>`
  display: inline-flex;
  margin-left: 6px;
  color: ${({ $on }) => ($on ? CUST.progressFill : CUST.mobileTrack)};
`;

export const Body = styled.div<{ $flush?: boolean }>`
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  /* Clip the step slide's horizontal travel so it can't spill a scrollbar. */
  overflow-x: hidden;
  /* The done screen fills to the bottom (its footer overlays the phone), so it
     drops the bottom padding the fixed CTA otherwise reserves. */
  padding: ${({ $flush }) => ($flush ? '8px 16px 0' : '8px 16px 104px')};
`;